import Enum from "../../enums/Enum";

const YesNoNotAvailableEnum = new Enum({
        YES: {name: "Yes"},
        NO: {name: "No"},
        NA: {name: "N/A"}
});

export default YesNoNotAvailableEnum;